import {createApi,fetchBaseQuery} from '@reduxjs/toolkit/query/react';

const authTags=[
	'Account',
	'login'
	];

function standardisedReturn(result,error,input,tags)
	{
	if (tags===undefined)
		{
		console.log(result,error,input);
		return [];
		}

	if (result?.failure)
		{
		if (result.failure==="not logged in")
			;
		else if (input&&input.onFailure)
			;
		else
			alert(result.failure);
		}

	if (result?.success)
		return tags;

	console.error(result,error,input);
	return tags;
	}

export const authApi=createApi(
	{
	reducerPath:'authApi',

	baseQuery:fetchBaseQuery(
		{
		baseUrl:'https://docsasudo.com',
		credentials:'include'
		}),

	tagTypes:authTags,

	endpoints:(builder)=>(
	{
	addUser:builder.mutation(
		{
		query:({email,admin,userManager})=>(
			{
			url:'login.php',
			method:'post',
			body:
				{
				action:'addUser',
				email,
				admin,
				userManager
				}
			})
		}),
	
	deleteUser:builder.mutation(
		{
		query:({id})=>(
			{
			url:'login.php',
			method:'POST',
			body:
				{
				action:'deleteUser',
				id:id
				}
			})
		}),
	getLoginStatus:builder.query(
			{
			query:()=>`login.php?action=getLoginStatus`,
			providesTags:(result,error,inputs)=>
				standardisedReturn(result,error,inputs,authTags)
			}),

		forgotPassword:builder.mutation(
			{
			query:(email)=>(
				{
				url:'login.php',
				method:'post',
				body:
					{
					action:'resetPassword',
					email
					}
				}),
			invalidatesTags:(result,error,inputs)=>
				standardisedReturn(result,error,inputs,[])
			}),

		createAccount:builder.mutation(
			{
			query:(object)=>(
				{
				url:'login.php',
				method:'post',
				body:
					{
					...object,
					action:'createAccount'
					}
				}),
			invalidatesTags:(result,error,inputs)=>
				standardisedReturn(result,error,inputs,['login','Account'])
			}),

		login:builder.mutation(
			{
			query:({email,password})=>(
				{
				url:'login.php',
				method:'post',
				body:
					{
					action:'login',
					email,
					password
					}
				}),
			invalidatesTags:(result,error,inputs)=>
				standardisedReturn(result,error,inputs,['login','Account'])
			}),

		logout:builder.mutation(
			{
			query:()=>(
				{
				url:'login.php',
				method:'post',
				body:
					{
					action:'logout'
					}
				}),
			invalidatesTags:(result,error,inputs)=>
				standardisedReturn(result,error,inputs,['login','Account'])
			}),

		resetPassword:builder.mutation(
			{
			query:({accessToken,email,password,currentPassword})=>(
				{
				url:'login.php',
				method:'post',
				body:
					{
					action:'changePassword',
					accessToken,
					email,
					password,
					currentPassword
					}
				})
			}),
		changeAliasUser:builder.mutation({
			  // note: an optional `queryFn` may be used in place of `query`
			query: ({aliasID}) => ({
				url: `login.php`,
				method:'post',
				body: {action:'aliasUser',aliasID},			
				}),
			invalidatesTags: (result,error,inputs)=>standardisedReturn(result, error, inputs,['Account'])
			}),

		changePassword:builder.mutation(
			{
			query:({email,currentPassword,password})=>(
				{
				url:'login.php',
				method:'post',
				body:
					{
					action:'changePassword',
					accessToken:'',
					email,
					currentPassword,
					password
					}
				})
			}),

		})
	});

export const {
	useAddUserMutation, useDeleteUserMutation,
	useGetLoginStatusQuery,
	useForgotPasswordMutation,
	useCreateAccountMutation,
	useLoginMutation,
	useLogoutMutation,
	useResetPasswordMutation,
	useChangePasswordMutation,
	useChangeAliasUserMutation
	}=authApi;